import type { ErrorReportRequest } from "./types";

/**
 * Один лист «Сообщить об ошибке» на весь сайт: его открывают кнопка «Нашли ошибку?», Ctrl+Enter, остров
 * рецептов (opts.onReport) и «Что в блюде» — все через openErrorReport. Событие окна, а не общий стор:
 * лист живёт в корне приложения (ErrorReportRoot), а звать его можно из любого чанка, даже из кода вне
 * React. Нет корня (тесты, служебная страница) — ничего не происходит.
 */
export const ERROR_REPORT_EVENT = "torsunov:error-report";

export const openErrorReport = (request: ErrorReportRequest = {}): void => {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent<ErrorReportRequest>(ERROR_REPORT_EVENT, { detail: request }));
};

/** Подписка корня на открытия; возвращает отписку. */
export const onOpenErrorReport = (fn: (request: ErrorReportRequest) => void): (() => void) => {
    const handler = (e: Event) => fn(((e as CustomEvent<ErrorReportRequest>).detail || {}) as ErrorReportRequest);
    window.addEventListener(ERROR_REPORT_EVENT, handler);
    return () => window.removeEventListener(ERROR_REPORT_EVENT, handler);
};
